export default __webpack_public_path__ + "static/slide-frame-plastic-341d23ee1c7be92670b3f12b2d9fc06f.png";